import React, { useEffect, useMemo, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import "../../Assets/Css/AddUpdateInvoice.scss";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { combineAddress } from "../../Lib/utils";
import { customStyle } from "../../Components/Style";
import { useFormik } from "formik";
import { addInvoiceSchema } from "../../Validations/addInvoiceValidation";
import { Spinner } from "react-bootstrap";
import { connect } from "react-redux";
import {
  addInvoice,
  getInvoiceId,
  getTaxesList,
  updateInvoice,
  getCurrencyList,
  getSystemSettings,
  getSingleInvoice,
  getInvoices,
} from "../../Services/Invoices/action";
import { getSearchedClient } from "../../Services/Clients/action";
import { useLocation, useNavigate } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";

function AddUpdateInvoice(props) {

  const [isTouched, setIsTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);
  const [selectedDiscountType, setSelectedDiscountType] = useState(null);
  const [notes, setNotes] = useState("");
  const [taxOptions, setTaxOptions] = useState([]);
  const [termsData, setTermsData] = useState([]);
  const [itemsData, setItemsData] = useState([]);
  const [taxesData, setTaxesData] = useState([]);
  const [discountsData, setDiscountsData] = useState({});
  const [discountAmount, setDiscountAmount] = useState(0);
  const [totalDiscount, setTotalDiscount] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalAfterDiscount, setTotalAfterDiscount] = useState(0);
  const [termIndexNumbers, setTermIndexNumbers] = useState(0);
  const [itemIndexNumbers, setItemIndexNumbers] = useState(0);
  const [show, setShow] = useState(false);
  const [rateLabel, setRateLabel] = useState("rate");
  const [qtyLabel, setQtyLabel] = useState("qty");
  const [rateInput, setRateInput] = useState();
  const [qtyInput, setQtyInput] = useState();
  const [subTotal, setSubTotal] = useState(0);
  const [clientName, setClientName] = useState("");
  const [clientEmail, setClientEmail] = useState("");
  const [clientMobile, setClientMobile] = useState("");
  const [clientAddress, setClientAddress] = useState("");
  const [invoiceId, setInvoiceId] = useState(1);
  const [defaultTaxOptions, setDefaultTaxOptions] = useState([]);
  const [isUpdate, setIsUpdate] = useState(false);
  const [defaultcurrencycode, setDefaultCurrencyCode] = useState("")
  const [defaultcurrencysymbol, setDefaultCurrencySymbol] = useState("");
  const [currencysymbol, setCurrencySymbol] = useState("")
  const [currency, setCurrency] = useState("");
  const [currencyrate, setCurrencyRate] = useState("");
  const [defaultClient, setDefaultClient] = useState({
    label: "",
    value: "",
  });
  const [deletedItem, setDeletedItem] = useState({
    items: [],
    taxes: [],
    terms: [],
  });

  const navigate = useNavigate();

  const location = useLocation();

  const defaultData = location?.state?.data;

  const handleClose = () => {
    setShow(false);
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await props.getInId();
      await props.getTaxes();
      await props.getCurrencyList();
      await props.getSystemSettings();
      await props.getInvoicesList(location.search);
      if (!defaultData?.invoiceId && isUpdate) {
        toast.error("Something went wrong");
        navigate("/invoice");
      }
      setIsLoading(false);
    })()
  }, [defaultData]);


  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const CurrentInvoice = await props?.invoices?.find((item) => item?.id === defaultData?.invoiceId?.value)

      const currencyCode = await props?.currencylist?.find((code) => code?.id === CurrentInvoice?.currency_id)?.code;

      const DefaultCurrencyCode = await props?.systemsettings?.find((item) => item?.key)?.value;

      const DefaultCurrencySymbol = await props?.currencylist?.find((item) => item.code === DefaultCurrencyCode)?.symbol;

      const CurrencySymbol = await props?.currencylist?.find((code) => code?.id === CurrentInvoice?.currency_id)?.symbol

      const CurrencyRate = await CurrentInvoice?.currency_rate

      setIsLoading(false);
      setDefaultCurrencyCode(DefaultCurrencyCode);
      setCurrencySymbol(CurrencySymbol);
      setDefaultCurrencySymbol(DefaultCurrencySymbol);
      setCurrency(currencyCode);
      setCurrencyRate(CurrencyRate);
    })()
  }, [props?.allInvoices, props?.currencylist, props?.invoices, props?.systemsettings])

  useEffect(() => {
    if (props.taxList) {
      setTaxOptions(props.taxList);
      setDefaultTaxOptions(props.taxList);
    }
    if (props.lastInvoiceId) {
      setInvoiceId(props.lastInvoiceId ? props.lastInvoiceId + 1 : 1);
    }
    if (props.lastInvoiceId && defaultData?.invoiceId) {
      setInvoiceId(defaultData?.invoiceId?.value);
      setIsUpdate(true);
    }
  }, [props.taxList, props.lastInvoiceId]);

  const handleChangeLabel = (rateInput, qtyInput) => {
    if (rateInput) {
      setRateLabel(rateInput);
    } else {
      return null;
    }
    if (qtyInput) {
      setQtyLabel(qtyInput);
    } else {
      return null;
    }
    handleClose();
  };

  const handleAddTaxAndDiscount = () => {
    if (!selectedTax && !discountAmount && !selectedDiscountType) {
      return toast.error("Please enter tax or discount");
    }
    if (selectedTax) {
      setTaxesData([...taxesData, selectedTax]);
      setTaxOptions(
        taxOptions.filter((tax) => {
          return tax.id != selectedTax.id;
        })
      );
      setSelectedTax(null);
    }

    if (discountAmount && !selectedDiscountType) {
      return toast.error("Please select discount type");
    }
    if (!discountAmount && selectedDiscountType) {
      return toast.error("Please enter discount amount");
    }
    if (discountAmount && selectedDiscountType) {
      setDiscountsData({
        type: selectedDiscountType.value,
        value: discountAmount,
      });
    }
  };

  const handleDeleteTax = (tax) => {
    let newTaxesData = taxesData;
    setTaxOptions([...taxOptions, tax]);
    setDeletedItem({
      ...deletedItem,
      taxes: [...deletedItem["taxes"], { ...tax, deleted_at: new Date() }],
    });
    setTaxesData(
      newTaxesData.filter((Tax) => {
        return Tax.id != tax.id;
      })
    );
  };

  useEffect(() => {
    setFieldValue("itemsData", itemsData);
    let total = 0;
    itemsData.forEach((item) => {
      total += item.amount;
    });
    setSubTotal(total);
    if (!totalTax && !totalDiscount) {
      setTotal(total);
    }
  }, [itemsData]);

  useEffect(() => {
    let final = 0;
    if (discountsData.type == "percentage") {
      final += subTotal * (discountsData.value / 100);
    } else {
      final += discountsData.value;
    }
    setTotalDiscount(Number.isInteger(parseFloat(final)) ? final : 0);
  }, [discountsData, subTotal]);

  useEffect(() => {
    if (subTotal) {
      setTotalAfterDiscount(subTotal - totalDiscount);
      if (totalTax == 0) {
        setTotal(subTotal - totalDiscount);
      }
    } else {
      setTotalAfterDiscount(subTotal);
    }
  }, [totalDiscount, subTotal]);

  useEffect(() => {
    let total = 0;
    taxesData.forEach((tax) => {
      total += totalAfterDiscount * (tax.value / 100);
    });
    setTotalTax(total);
  }, [taxesData, totalAfterDiscount]);

  useEffect(() => {
    setTotal(
      totalAfterDiscount ? totalAfterDiscount + totalTax : totalAfterDiscount
    );
  }, [totalTax, totalAfterDiscount]);

  const debounce = (func, timeout = 1000) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(this, args);
      }, timeout);
    };
  };

  const loadClientOptions = (inputValue, callback) => {
    if (inputValue.length > 2) {
      const getClientDebounce = debounce(props.getClient, 5000);
      getClientDebounce(inputValue);
      callback(
        props.clients.map((client) => {
          return { label: client?.name, value: client };
        })
      );
    }
  };

  const discountTypeOptions = [
    { id: 1, value: "percentage", label: "Percentage" },
    { id: 2, value: "fixed", label: "Fixed" },
  ];

  const defaultTermData = {
    indexNo: 0,
    term: "",
  };

  const defaultItemData = {
    indexNo: 0,
    description: "",
    rate: 0,
    qty: 0,
    amount: 0,
  };

  const handleAddRow = (Data, setData, indexNumbers, setIndexNumbers, type) => {
    let blankData;
    if (type == "term") {
      blankData = defaultTermData;
    }
    if (type == "item") {
      blankData = defaultItemData;
    }
    if (Data.length > 0) {
      blankData.indexNo = Data[Data.length - 1].indexNo + 1;
      setIndexNumbers(parseFloat(indexNumbers) + 1)
    } else {
      if (!Number.isInteger(parseFloat(indexNumbers))) {
        setIndexNumbers(1);
        blankData.indexNo = 1;
      } else {
        setIndexNumbers(parseFloat(indexNumbers) + 1);
        blankData.indexNo = parseFloat(indexNumbers) + 1;
      }
    }

    setData([...Data, blankData]);
  };

  // TODO : understand it
  const handleChange = (indexNo, value, Data, setData, type) => {
    let copyData = Data;
    copyData[indexNo][type] = value;
    if (copyData[indexNo]["rate"] && copyData[indexNo]["qty"]) {
      copyData[indexNo]["amount"] = copyData[indexNo]["rate"] * copyData[indexNo]["qty"];
    }
    setData([...copyData]);
  };

  const handleDelete = (indexNo, Data, setData, type) => {
    let copyData = Data;

    let deleteField = Data.filter((field) => {
      return field?.indexNo === indexNo;
    });


    deleteField = { ...deleteField[0], deleted_at: new Date() };
    if (type === "terms") {
      setDeletedItem({
        ...deletedItem,
        terms: [...deletedItem["terms"], deleteField],
      });

      setTermIndexNumbers(copyData.length - 1);
    } else if (type === "items") {
      setDeletedItem({
        ...deletedItem,
        items: [...deletedItem["items"], deleteField],
      });

      setItemIndexNumbers(copyData.length - 1);
    }
    // copyData.splice(indexNo, 1)

    copyData = Data.filter((field) => {
      return field?.indexNo !== indexNo;
    }).map(item => {
      if (item.indexNo > indexNo) {
        return { ...item, indexNo: item.indexNo - 1 }
      }
      return { ...item }
    })
    setData([...copyData]);
  };

  const handleChangeIndex = (
    indexNo,
    value,
    Data,
    setData,
    setIndexNumbers
  ) => {
    let copyData = Data;
    copyData[indexNo]["indexNo"] = value;
    setData(copyData);
    setIndexNumbers(value);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();
    setIsTouched(false);
    submitForm();
    setIsTouched(true);
    errors.itemsData && toast.error(errors.itemsData);
  };

  const onSubmit = async (values, actions) => {
    setIsLoading(true);
    const invoice = {
      title: values.title,
      client_id: values.client.value.id,
      date: values.date,
      discount: discountsData.value ? discountsData.value : null,
      discount_type: selectedDiscountType?.value ? selectedDiscountType?.value : null,
      total: total,
      subtotal: subTotal,
      taxes: totalTax || 0,
      rate_label: rateLabel,
      qty_label: qtyLabel,
      notes: notes,
      currency: currency,
      currency_rate: currencyrate,
      invoiceTerms: termsData
        ? [
          ...termsData.map((ele) => {
            return { term: ele.term, id: ele.id };
          }),
          ...deletedItem["terms"],
        ]
        : [],
      invoiceItems: [
        ...itemsData.map((ele) => {
          return {
            description: ele.description,
            rate: ele.rate,
            qty: ele.qty,
            id: ele.id,
          };
        }),
        ...deletedItem["items"],
      ],
      invoiceTaxMap: [
        ...taxesData.map((tax) => {
          if ("tax_id" in tax === false) {
            return {
              tax_id: tax.id,
            };
          }
        }).filter((value) => value != null),
        ...deletedItem["taxes"],
      ],
      notes: notes,
    };
    try {
      !isUpdate
        ? await props.addInvoice(invoice)
        : await props.updateInvoice({ ...invoice, id: invoiceId }, invoiceId);

      if (props.invoiceSuccess && isUpdate === false) {
        await props.getInId();
        if (props.lastInvoiceId) {
          setInvoiceId(props.lastInvoiceId ? props.lastInvoiceId + 1 : 1);
        }
        setClientName("");
        setClientAddress("");
        setClientEmail("");
        setClientMobile("");
        setSelectedTax(null);
        setSelectedDiscountType(null);
        setNotes("");
        setTermsData([]);
        setItemsData([]);
        setTaxesData([]);
        setDiscountsData({});
        setDiscountAmount(0);
        setTotalDiscount(0);
        setTotalTax(0);
        setTotal(0);
        setTotalAfterDiscount(0);
        setTermIndexNumbers(0);
        setItemIndexNumbers(0);
        setRateLabel("rate");
        setQtyLabel("qty");
        setRateInput();
        setQtyInput();
        setSubTotal(0);
        setIsLoading(false);
        setFieldValue("title", "");
        setFieldValue("client", null);
        setFieldValue("date", new Date());
        setFieldValue("itemsData", []);
      } else if (props.invoiceSuccess && isUpdate) {
        setIsUpdate(false);
      }
    } catch (error) {
      console.log("Error While Submiting", error);
    } finally {
      navigate("/invoice");
      setIsLoading(false);
    }

  };

  useEffect(() => {
    if (defaultData?.invoiceId
      //  && defaultTaxOptions.length > 0
    ) {
      let invoiceData = props?.allInvoices
        ? props?.allInvoices?.filter((invoice) => {
          return invoice.id === defaultData.invoiceId.value;
        })
        : [];
      console.log(defaultData, props?.allInvoices, ' <=== default data invoice id...')
      invoiceData.map((invoice) => {
        setClientName(invoice.clientInvoices.name);
        setClientAddress(combineAddress(invoice.clientInvoices));
        setClientEmail(invoice.clientInvoices.email);
        setClientMobile(invoice.clientInvoices.mobile);
        setFieldValue("date", new Date(invoice.date));
        setFieldValue("title", invoice.title);
        let value = {
          label: invoice?.clientInvoices?.name,
          value: { ...invoice?.clientInvoices },
        };
        setFieldValue("client", value);
        setDefaultClient({
          label: invoice?.clientInvoices?.name,
          value: invoice?.clientInvoices,
          id: invoice?.clientInvoices?.id,
        });
        setInvoiceId(invoice.id);
        invoice.notes !== null ? setNotes(invoice.notes) : setNotes("");
        setTermsData(
          invoice?.invoiceTerms?.map((term, index) => {
            return {
              indexNo: index + 1,
              term: term.term,
              id: term.id,
            };
          })
        );
        setItemsData(
          invoice?.invoiceItems?.map((item, index) => {
            return {
              indexNo: index + 1,
              description: item.description,
              rate: item.rate,
              qty: item.qty,
              amount: item.rate * item.qty,
              id: item.id,
            };
          })
        );
        let taxes = invoice?.invoiceTaxMap?.map((item) => {
          let defaultTax = defaultTaxOptions.find((tax) => {
            return tax.id == item.tax_id;
          });

          return {
            label: defaultTax?.label,
            value: defaultTax?.value,
            ...item,
          };
        });
        const filteredObjects = defaultTaxOptions.filter(tax =>
          !taxes.some(item => item.tax_id === tax.id)
        );
        setTaxOptions(filteredObjects);
        setTaxesData(taxes);
        setDiscountAmount(invoice.discount);
        setTotalDiscount(invoice.discount);
        setRateLabel(invoice.rate_label);
        setQtyLabel(invoice.qty_label);
        let invoiceDisc = discountTypeOptions.filter((discount) => {
          return discount.value === invoice.discount_type;
        });
        setSelectedDiscountType(invoiceDisc[0]);
        setDiscountsData({
          type: invoice.discount_type,
          value: invoice.discount,
        });
        setNotes(invoice.notes ? invoice.notes : "");
        return;
      });
    }
    if (!defaultData?.invoiceId && isUpdate) {
      toast.error("Something went wrong");
      navigate("/invoice");
    }
  }, [defaultData, defaultTaxOptions, props.allInvoices]);
  const { values, errors, setFieldValue, submitForm } = useFormik({
    initialValues: {
      client: null,
      date: new Date(),
      title: "",
      itemsData: [],
    },
    validationSchema: addInvoiceSchema,
    onSubmit,
  });

  useEffect(() => {
    if (values.client) {
      setClientName(values.client.value.name);
      setClientEmail(values.client.value.email);
      setClientMobile(values.client.value.mobile);
      setClientAddress(combineAddress(values.client.value));
    }
  }, [values.client]);


  const handleCurrencyChange = (e) => {
    e.preventDefault();
    const filterCurrency = props?.currencylist?.filter((item) => item.code === e.target.value)
    setCurrency(filterCurrency[0].code)
    setCurrencyRate(1)
  }


  return (
    <>
      <Sidebarlayout>
        <div className="addInvoice-main">
          <div className="page-title">
            <h4> {isUpdate ? "Update" : "Create"} Invoice</h4>
            <div className="edit-btn">
              <button
                type="submit"
                className="custom-btn"
                onClick={handleSubmitClick}
              >
                {props.loading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Save"
                )}
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="card-custom">
                <div className="client-part">
                  <div className="client-selection">
                    <label className="labeling">
                      <div className="label-gap">Client</div>
                      <AsyncSelect
                        isDisabled={isLoading}
                        defaultValue={defaultClient}
                        value={defaultClient}
                        onChange={(val) => {
                          setFieldValue("client", val);
                          setDefaultClient({
                            label: val.label,
                            value: val.value,
                            id: val.value.id,
                          });
                        }}
                        loadOptions={loadClientOptions}
                        placeholder={"Client"}
                        styles={customStyle}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#5757fe",
                            primary: "#5757fe",
                          },
                        })}
                      />
                      {isTouched && errors.client && (
                        <p className="error-text">{errors.client}</p>
                      )}
                    </label>
                  </div>
                  <div className="client-details">
                    <div className="detail-content">
                      <h6 className="label">Name</h6>
                      <h6 className="value">{clientName}</h6>
                    </div>
                    <div className="detail-content">
                      <h6 className="label">Email</h6>
                      <h6 className="value">{clientEmail}</h6>
                    </div>
                    <div className="detail-content">
                      <h6 className="label">Mobile</h6>
                      <h6 className="value">{clientMobile}</h6>
                    </div>
                    <div className="detail-content">
                      <h6 className="label">Address</h6>
                      <h6 className="value">{clientAddress}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card-custom">
                <div className="right-part">
                  <div className="date">
                    <label className="labeling">
                      <div className="label-gap">Date</div>
                      <DatePicker
                        disabled={isLoading}
                        selected={values.date}
                        onChange={(value) => {
                          setFieldValue("date", value);
                        }}
                        className={`${isTouched && errors.date && "input-error"
                          }`}
                      />
                      {isTouched && errors.date && (
                        <p className="error-text">{errors.date}</p>
                      )}
                    </label>
                  </div>
                  <div className="invoice">
                    <h6 className="label">Invoice#</h6>
                    <input
                      className="input-field-i"
                      disabled
                      value={invoiceId}
                    />
                  </div>
                  <div className="currency">
                    <h6 className="label">Currency #</h6>
                    <select name="currency-select" onChange={handleCurrencyChange} value={currency}>
                      {props?.currencylist?.map((code) => (
                        <option value={code.code}>{code.code}</option>
                      ))}
                    </select>
                    {currency === defaultcurrencycode ? ("")
                      : (
                        <input type="text" value={currencyrate} onChange={(e) => setCurrencyRate(e.target.value)} />
                      )
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-8">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Title</h6>
                </div>
                <div className="card-custom">
                  <input
                    disabled={isLoading}
                    type="text"
                    className={`title-input ${isTouched && errors.title && "input-error"
                      }`}
                    value={values.title}
                    onChange={(e) => setFieldValue("title", e.target.value)}
                  />
                  {isTouched && errors.title && (
                    <p className="error-text">{errors.title}</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Items</h6>
                  <div className="edit-btn">
                    <button
                      disabled={isLoading}
                      className="custom-btn"
                      onClick={(e) => {
                        e.preventDefault();
                        setShow(true);
                      }}
                    >
                      Add Heading
                    </button>
                  </div>
                </div>
                <div className="card-custom">
                  <div className="addDeleteTableRow-main">
                    <table className="table-container">
                      <thead>
                        <tr>
                          <th className="sr" width="11%">
                            #
                          </th>
                          <th className="des" width="35%">
                            description
                          </th>
                          <th className="rate" width="15%">
                            {rateLabel ? rateLabel : "rate"}
                          </th>
                          <th className="qty" width="13%">
                            {qtyLabel ? qtyLabel : "qty"}
                          </th>
                          <th className="amount" width={currency === defaultcurrencycode ? "15%" : "12%"}>
                            amount(~)
                          </th>
                          {currency === defaultcurrencycode ? (
                            ""
                          ) : (
                            <th className="amount" width="12%" >
                              amount(INR)
                            </th>
                          )}
                          <th className="button" width="11%">
                            del
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {itemsData.length
                          ? itemsData.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <input
                                    disabled={isLoading}
                                    type="text"
                                    value={data.indexNo}
                                    onChange={(e) => {
                                      handleChangeIndex(
                                        index,
                                        e.target.value,
                                        itemsData,
                                        setItemsData,
                                        setItemIndexNumbers
                                      );
                                    }}
                                    name="no"
                                    className="form-control"
                                  />
                                </td>
                                <td>
                                  {/* TODO: change here */}
                                  <textarea
                                    name="desription"
                                    id="invoice-desc"
                                    value={data.description}
                                    onChange={(e) => {
                                      handleChange(
                                        index,
                                        e.target.value,
                                        itemsData,
                                        setItemsData,
                                        "description"
                                      );
                                    }}
                                    className="form-control"
                                  //   className="input-css"
                                  />
                                </td>
                                <td>
                                  <input
                                    disabled={isLoading}
                                    type="text"
                                    value={data.rate || 0}
                                    onChange={(e) =>
                                      handleChange(
                                        index,
                                        e.target.value,
                                        itemsData,
                                        setItemsData,
                                        "rate"
                                      )
                                    }
                                    name="rate"
                                    className="form-control"
                                  />{" "}
                                </td>
                                <td>
                                  <input
                                    disabled={isLoading}
                                    type="text"
                                    value={data.qty || 0}
                                    onChange={(e) =>
                                      handleChange(
                                        index,
                                        e.target.value,
                                        itemsData,
                                        setItemsData,
                                        "qty"
                                      )
                                    }
                                    name="qty"
                                    className="form-control"
                                  />{" "}
                                </td>
                                <td>
                                  <input
                                    type="text"
                                    value={data.amount || 0}
                                    disabled
                                    onChange={(e) =>
                                      handleChange(
                                        index,
                                        e.target.value,
                                        itemsData,
                                        setItemsData,
                                        "amount"
                                      )
                                    }
                                    name="amount"
                                    className="form-control"
                                  />{" "}
                                </td>
                                {currency === defaultcurrencycode ? ("") : (
                                  <td>
                                    <input
                                      type="text"
                                      value={parseFloat((data.amount * currencyrate || 0).toFixed(2))}
                                      disabled
                                      onChange={(e) =>
                                        handleChange(
                                          index,
                                          e.target.value,
                                          itemsData,
                                          setItemsData,
                                          "amount"
                                        )
                                      }
                                      name="amount"
                                      className="form-control"
                                    />{" "}
                                  </td>
                                )
                                }
                                <td>
                                  <button
                                    disabled={isLoading}
                                    className="btn btn-outline-danger delete-btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDelete(
                                        data.indexNo,
                                        itemsData,
                                        setItemsData,
                                        "items"
                                      );
                                    }}
                                  >
                                    <Icon icon="material-symbols:close" className="close-icon" />
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                          : null}
                      </tbody>
                    </table>
                    <div className="bottom-btn-div">
                      <button
                        disabled={isLoading}
                        className="custom-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddRow(
                            itemsData,
                            setItemsData,
                            itemIndexNumbers,
                            setItemIndexNumbers,
                            "item"
                          );
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Taxes & Discounts</h6>
                </div>
                <div className="card-custom">
                  <p className="subtitle-text">Discount</p>
                  <div className="input-row">
                    <input
                      disabled={isLoading}
                      type="number"
                      className="text-input"
                      value={discountAmount}
                      onChange={(e) => {
                        setDiscountAmount(e.target.value);
                      }}
                    />
                    <div className="select-container">
                      <Select
                        isDisabled={isLoading}
                        defaultValue={selectedDiscountType}
                        value={selectedDiscountType}
                        onChange={setSelectedDiscountType}
                        options={discountTypeOptions}
                        placeholder={"Type"}
                        className={"select-box"}
                        styles={{
                          option: (base) => ({
                            ...base,
                            "&:hover": {
                              color: "#fff",
                            },
                            "&:focus-visible": {
                              color: "#fff",
                            },
                            "&:active": {
                              color: "#fff",
                            },
                            "&:target": {
                              color: "#fff",
                            },
                          }),
                        }}
                        theme={(theme) => ({
                          ...theme,
                          colors: {
                            ...theme.colors,
                            primary25: "#5757fe",
                            primary: "#5757fe",
                          },
                        })}
                      />
                    </div>
                  </div>
                  <p className="subtitle-text">Tax</p>
                  <div className="select-container">
                    <Select
                      isDisabled={isLoading}
                      defaultValue={selectedTax}
                      value={selectedTax}
                      onChange={setSelectedTax}
                      className={"select-box"}
                      options={taxOptions}
                      placeholder={"Tax"}
                      styles={{
                        option: (base) => ({
                          ...base,
                          "&:hover": {
                            color: "#fff",
                          },
                          "&:focus-visible": {
                            color: "#fff",
                          },
                          "&:active": {
                            color: "#fff",
                          },
                          "&:target": {
                            color: "#fff",
                          },
                        }),
                      }}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                    <div className="edit-btn">
                      <button
                        disabled={isLoading}
                        type="button"
                        className="custom-btn"
                        onClick={handleAddTaxAndDiscount}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Taxes & Discounts</h6>
                </div>
                <div className="card-custom">
                  <table className="table-container tax-table">
                    <tbody>
                      <tr>
                        <td>Sub Total</td>
                        <td>:</td>
                        <td>{defaultcurrencysymbol || ""}{parseFloat(subTotal * currencyrate || 0).toFixed(2)}
                        </td>
                        {currency === defaultcurrencycode ? (
                          <td></td>
                        ) : (
                          <td>{currencysymbol || ""}{parseFloat(subTotal || 0).toFixed(2)}</td>
                        )}
                      </tr>
                      <tr>
                        <td>Total Discount</td>
                        <td>:</td>
                        <td> {defaultcurrencysymbol || ""}{parseFloat(totalDiscount * currencyrate || 0).toFixed(2)}</td>
                        {currency === defaultcurrencycode ? (
                          <td></td>
                        ) : (
                          <td>{currencysymbol || ""}{parseFloat(totalDiscount || 0).toFixed(2)}</td>
                        )}
                      </tr>
                      {taxesData.length
                        ? taxesData.map((tax, index) => {
                          return (
                            <tr key={index}>
                              <td>{`${tax?.label} (${tax?.value}%)`}</td>
                              <td>:</td>
                              <td>{defaultcurrencysymbol || ""}{parseFloat(totalAfterDiscount * (tax.value / 100) * currencyrate || 0).toFixed(2)}</td>
                              {currency === defaultcurrencycode ? (
                                <td></td>
                              ) : (
                                <td>{currencysymbol || ""}{parseFloat(totalAfterDiscount * (tax.value / 100) || 0).toFixed(2)}</td>
                              )}
                              <td>
                                <button
                                  disabled={isLoading}
                                  className="btn btn-outline-danger delete-btn"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleDeleteTax(tax);
                                  }}
                                >
                                  <Icon icon="material-symbols:close" className="close-icon" />
                                </button>
                              </td>
                            </tr>
                          );
                        })
                        : null}
                      <tr>
                        <td>Total Tax</td>
                        <td>:</td>
                        <td>{defaultcurrencysymbol || ""}{parseFloat(totalTax * currencyrate || 0).toFixed(2)}</td>
                        {currency === defaultcurrencycode ? (
                          <td></td>
                        ) : (
                          <td>{currencysymbol || ""}{parseFloat(totalTax || 0).toFixed(2)}</td>
                        )}
                      </tr>
                      <tr>
                        <td>Total</td>
                        <td>:</td>
                        <td>{defaultcurrencysymbol || ""}{parseFloat(total * currencyrate || 0).toFixed(2)}</td>
                        {currency === defaultcurrencycode ? (
                          <td></td>
                        ) : (
                          <td>{currencysymbol || ""}{parseFloat(total || 0).toFixed(2)}</td>
                        )}
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Extra Notes</h6>
                </div>
                <div className="card-custom">
                  {/* TODO: change here */}
                  <textarea
                    name="notes"
                    id="invoice-notes"
                    value={notes}
                    onChange={(e) => {
                      setNotes(e.target.value);
                    }}
                    // className="form-control"
                    className="input-css"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="custom-div">
                <div className="page-title">
                  <h6>Terms</h6>
                </div>
                <div className="card-custom">
                  <div className="addDeleteTableRow-main">
                    <table className="table-container">
                      <thead>
                        <tr>
                          <th className="sr">#</th>
                          <th className="term">term</th>
                          <th className="button">del</th>
                        </tr>
                      </thead>
                      <tbody>
                        {termsData.length
                          ? termsData.map((data, index) => {
                            return (
                              <tr key={index}>
                                <td>
                                  <span>{data.indexNo}</span>
                                </td>
                                <td>
                                  {/* TODO: change here */}
                                  <textarea
                                    name="desription"
                                    id="invoice-desc"
                                    value={data.term}
                                    onChange={(e) => {
                                      handleChange(
                                        index,
                                        e.target.value,
                                        termsData,
                                        setTermsData,
                                        "term"
                                      );
                                    }}
                                    //   className="form-control"
                                    className="input-css"
                                  />
                                </td>
                                <td>
                                  <button
                                    disabled={isLoading}
                                    className="btn btn-outline-danger delete-btn"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleDelete(
                                        data.indexNo,
                                        termsData,
                                        setTermsData,
                                        "terms"
                                      );
                                    }}
                                  >
                                    x
                                  </button>
                                </td>
                              </tr>
                            );
                          })
                          : null}
                      </tbody>
                    </table>
                    <div className="bottom-btn-div">
                      <button
                        disabled={isLoading}
                        className="custom-btn"
                        onClick={(e) => {
                          e.preventDefault();
                          handleAddRow(
                            termsData,
                            setTermsData,
                            termIndexNumbers,
                            setTermIndexNumbers,
                            "term"
                          );
                        }}
                      >
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Modal
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
          >
            <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                Edit heading labels
              </Modal.Title>
            </Modal.Header>
            <Modal.Body className="show-grid details-model">
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Rate label</Form.Label>
                <Form.Control
                  defaultValue={rateLabel}
                  onChange={(e) => setRateInput(e.currentTarget.value)}
                  type="text"
                  placeholder=""
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Qty label</Form.Label>
                <Form.Control
                  defaultValue={qtyLabel}
                  onChange={(e) => setQtyInput(e.currentTarget.value)}
                  type="text"
                  placeholder=""
                />
              </Form.Group>
              <div className="edit-btn">
                <button
                  className="custom-btn"
                  onClick={() => handleChangeLabel(rateInput, qtyInput)}
                >
                  Save
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </Sidebarlayout >
    </>
  );
}
export const mapStateToProps = (state) => {
  return {
    taxList: state.invoicesReducer.taxList,
    invoices: state.invoicesReducer.invoices.rows,
    allInvoices: state.invoicesReducer.invoices.rows,
    lastInvoiceId: state.invoicesReducer.invoiceId,
    clients: state.clientsReducer.searchedClients,
    invoiceSuccess: state.invoicesReducer.success,
    loading: state.invoicesReducer.loading,
    currencylist: state.invoicesReducer.currencylist,
    systemsettings: state.invoicesReducer.systemsettings,
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    getTaxes: () => {
      dispatch(getTaxesList());
    },
    getInId: () => {
      dispatch(getInvoiceId());
    },
    addInvoice: (invoice) => {
      dispatch(addInvoice(invoice));
    },
    getClient: (inputValue) => {
      dispatch(getSearchedClient(inputValue));
    },
    getInvoicesList: (params) => {
      dispatch(getInvoices(params));
    },
    updateInvoice: (invoice, id) => {
      dispatch(updateInvoice(invoice, id));
    },
    getCurrencyList: () => {
      dispatch(getCurrencyList())
    },
    getSystemSettings: () => {
      dispatch(getSystemSettings())
    }
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(AddUpdateInvoice);